const selector = '.elementinpagenav';

export function JumpLinks() {
  const url = document.location.href.match(/(^[^#]*)/)[0];
  const hash = document.location.hash;

  function generateAnchorId(index, text) {
    const id = text.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
    return `${id}-${index}`;
  }

  function scrollToTarget(target, targetHash) {
    window.scroll({
      top: target.offsetTop,
      left: 0,
      behavior: 'smooth',
    });

    if (targetHash) {
      const newURL = new URL(document.URL);
      newURL.hash = targetHash;

      setTimeout(() => {
        document.location.href = newURL;
      }, 500);
    }
  }

  // Looks for header (h2 in the entire page content and create anchors and anchor links
  document.querySelectorAll(selector).forEach((el) => {
    const list = el.querySelector('#inpagenav');

      // Find H2 and anchors
    const headers = document.querySelectorAll('.typography h2:not(.no-anchor), .typography .anchor');

    headers.forEach((header, index) => {
      const anchorName = generateAnchorId(index, header.textContent);
      // Create actual anchors
      const anchor = document.createElement('a');
      anchor.setAttribute('name', anchorName);
      anchor.setAttribute('id', anchorName);
      // Insert Anchor
      header.parentNode.insertBefore(anchor, header);
      // Add jump link
      const link = document.createElement('a');
      link.setAttribute('href', `${url}#${anchorName}`);
      link.textContent = header.textContent;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToTarget(anchor, `#${anchorName}`);
      });

      const listItem = document.createElement('li');
      listItem.appendChild(link);

      list.appendChild(listItem);
    });

    list.classList.remove('loading');
  });

  // Scroll to hash if exists
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      scrollToTarget(target, hash);
    }
  }
}

export default function init() {
  if (!window.MSInputMethodContext && !document.documentMode) {
    if (document.querySelector(selector)) JumpLinks();
  }
}
